var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.176,
    height: 53.756,
    viewBox: "0 0 44.176 53.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(-81 -623.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(82 624.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(1.36 19.636)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Upload",
    transform: "translate(0 30.12)",
    fill: "#3c4253",
    fontSize: 11,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Upload")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload-cloud",
    "data-name": "Icon feather-upload-cloud",
    transform: "translate(15.963 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M20.889,22.445,16.445,18,12,22.445",
    transform: "translate(-12 -18)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M18,18V31.213",
    transform: "translate(-13.555 -18)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M20.889,22.445,16.445,18,12,22.445",
    transform: "translate(-12 -18)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M75.26,194.112a8.692,8.692,0,0,1-8.692-8.692h0a8.692,8.692,0,0,1,8.692-8.693",
    transform: "translate(-66.568 -165.324)",
    fill: "none",
    stroke: "#b1b8c6",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M106.33,194.112a8.692,8.692,0,0,0,8.693-8.692h0a8.693,8.693,0,0,0-8.693-8.693",
    transform: "translate(-72.847 -165.324)",
    fill: "none",
    stroke: "#b1b8c6",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M77.169,175.463a12.278,12.278,0,0,1,12.278-12.278h0a12.278,12.278,0,0,1,12.278,12.278",
    transform: "translate(-68.242 -163.185)",
    fill: "none",
    stroke: "#b1b8c6",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a7fddde70d8c01274d2e0d50033e6b71.svg";
export { ForwardRef as ReactComponent };